import { Call, CallEndReason, RemoteParticipant, CallAgent } from '@azure/communication-calling';
import { ChatClient } from '@azure/communication-chat';
import { SelectionState } from 'core/RemoteStreamSelector';
import { Reducer } from 'redux';
import {
  CALL_ADDED,
  CALL_REMOVED,
  SET_CALL_STATE,
  SET_GROUP,
  SET_DOMINANT_PARTICIPANTS,
  SET_PARTICIPANTS,
  CallTypes,
  SET_CALL_AGENT,
  CHAT_MESSAGE_RECEIVED,
  SET_CHAT_CLIENT,
  SET_SERVER_CALL_ID
} from '../actions/calls';

export interface CallsState {
  callAgent?: CallAgent;
  group: string;
  call?: Call;
  callState: string;
  incomingCallEndReason: CallEndReason | undefined;
  groupCallEndReason: CallEndReason | undefined;
  remoteParticipants: RemoteParticipant[];
  attempts: number;
  dominantParticipants: SelectionState[];
  chatMessage: string;
  chatClient?: ChatClient;
  serverCallId?: string;
  allMessages: any;
}

const initialState: CallsState = {
  callAgent: undefined,
  call: undefined,
  callState: 'None',
  incomingCallEndReason: undefined,
  groupCallEndReason: undefined,
  remoteParticipants: [],
  dominantParticipants: [],
  group: '',
  attempts: 0,
  chatMessage: '',
  chatClient: undefined,
  serverCallId: undefined,
  allMessages: []
};

export const callsReducer: Reducer<CallsState, CallTypes> = (state = initialState, action: any): CallsState => {
  console.log(action, 'callsReducer');
  switch (action.type) {
    case SET_CALL_AGENT:
      return { ...state, callAgent: action.callAgent };
    case CALL_ADDED:
      return { ...state, call: action.call };
    case CALL_REMOVED:
      return {
        ...state,
        call: undefined,
        remoteParticipants: [],
        incomingCallEndReason: action.incomingCallEndReason,
        groupCallEndReason: action.groupCallEndReason,
        allMessages:[]
      };
    case SET_CALL_STATE:
      return { ...state, callState: action.callState };
    case SET_DOMINANT_PARTICIPANTS:
      return { ...state, dominantParticipants: action.dominantParticipants };
    case SET_PARTICIPANTS:
      return { ...state, remoteParticipants: action.remoteParticipants };
    case SET_GROUP:
      return { ...state, group: action.group };
    case CHAT_MESSAGE_RECEIVED:
      console.log(action, 'action in calls reducer related to received chat message');
      return {
        ...state,
        chatMessage: action.message,
        allMessages: state?.allMessages && state?.allMessages.length > 0 ? [ ...state?.allMessages,{ message: action.message, messageType: action.messageType }] : [ { message: action.message, messageType: action.messageType }]
      };
    case SET_CHAT_CLIENT:
      return { ...state, chatClient: action.chatClient };
    case SET_SERVER_CALL_ID:
      return { ...state, serverCallId: action.serverCallId };
    default:
      return state;
  }
};
